import React, { useState, useEffect, useRef } from 'react';
// import { useHistory, useLocation } from 'react-router-dom';
import Header from "../../../Components/Header/Header";
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faFile, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col, Modal, Form, Button, Table } from 'react-bootstrap';
import { faPlus, faXmark, faPencilAlt, faPaperclip, } from '@fortawesome/free-solid-svg-icons';
import AssetsIcon from '../../../assets/images/oparation.svg';
import AssetsIconw from '../../../assets/images/oparation_a.svg';
import view from "../../../assets/images/view.svg";
import Select from 'react-select';

import Docmnt from '../../../assets/images/google-docs.png';
import Cargoplane from "../../../assets/images/plane.svg";
import update_icon from '../../../../src/assets/images/update_icon.png';
import Cargotruck from "../../../assets/images/cargo-truck.png";
import flag_icon from "../../../assets/images/flag.png";
import { Link } from 'react-router-dom';
import ActivityComments from '../../../Components/common/ActivityComments';
import ImageUpload from '../../../Components/common/ImageUpload';
import { GETULDDETAILS, MVTHDETAILS } from '../../../Utils/conts';
import { withRFSToken } from '../../../Services/axios';
import { GETAGENT, GETDESTINATION, GETOWNERCODE, RECOVERYDETAILS, SAVEHANDLER, SAVERECOVERY, SROPENCLOSE, STATIONHANDLER, STATIONLIST, ULDADDRESSSAVE } from '../../../Utils/conts.js';
import Accordion from 'react-bootstrap/Accordion';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import Overview from './common/Overview';
import Attachment from './common/Attachment';
// import History from './common/History';
import Message from './common/Message';
import Charges from './common/Charges';
import Details from './common/Details';
import Doc from './common/DocManagement.js';
import ConfModal from '../../../Components/common/ConfModal.js';

import { toast } from 'react-toastify';
import Stations from './common/Stations.js';
import { CallApi } from '../../../Components/common/CommonFunctions.js';
import DetailsModal from '../../../Components/common/DetailsModal.js';
import MessageInfo from '../../../Components/common/SR/MessageInfo.js';
import Attachments from './common/Attachments.js';

const OverviewDetails = () => {
    const queryParameters = new URLSearchParams(window.location.search);

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const initTab = localStorage.getItem('ODTab')
    const [selectedButton, setSelectedButton] = useState('ov');
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [tabChange, setTabChange] = useState(false);
    const [tabChangeData, setTabChangeData] = useState('');
    const [triggerChild, setTriggerChild] = useState(false);

    const [confSec, setConfSec] = useState('');
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});

    const [closeRecModal, setCloseRecModal] = useState(false);
    const [recStat, setRecStat] = useState('');

    const [editFiles, setEditFiles] = useState([]);
    const [msgSec, setMsgSec] = useState({});

    const [assignUserOpt, setAssignUserOpt] = useState([]);
    const [priorityOpt, setPriorityOpt] = useState([]);
    const [subStatusOpt, setSubStatus] = useState([]);
    const [caseStatusOpt, setCaseStatus] = useState([]);
    const [spec, setSpec] = useState([]);
    const [solutions, setSolutions] = useState([]);

    const [formData, setFormData] = useState({});
    const [isEditable, setIsEditable] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState('');
    const [tabSec, setTabSec] = useState('');
    const [closeStatus, setCloseStatus] = useState('');

    const storedData = JSON.parse(localStorage.getItem('RecoveryEdit'));
    const handlerData = JSON.parse(localStorage.getItem('Handler_stn'));

    const fetchAssignUser = async () => {
        try {

            const res = await withRFSToken.post('service-recovery/assign-user-list', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setAssignUserOpt(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchPriority = async () => {
        try {

            const res = await withRFSToken.post('get-meta-list', { type_id: '19' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setPriorityOpt(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchSubStatus = async () => {
        try {

            const res = await withRFSToken.post('get-meta-list', { type_id: '20' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setSubStatus(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchCaseStatus = async () => {
        try {

            const res = await withRFSToken.post('get-meta-list', { type_id: '6' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setCaseStatus(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchSpec = async () => {
        try {

            const res = await withRFSToken.post('get-meta-list', { type_id: '22' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setSpec(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchSolution = async () => {
        try {

            const res = await withRFSToken.post('get-meta-list', { type_id: '23' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setSolutions(innerData)
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        if (storedData) {

            if (storedData.selb) { setSelectedButton(storedData.selb) } else { setSelectedButton(initTab || 'ov') }

            loadDetails(storedData.service_recovery_id);
        }
        fetchAssignUser();
        fetchPriority();
        fetchCaseStatus();
        fetchSubStatus();
        fetchSpec();
        fetchSolution();
        isMounted.current = true;
    }, []);

    const loadDetails = async (uldNumber) => {
        setIsLoading(true)
        try {
            const res = await withRFSToken.post(RECOVERYDETAILS, { service_recovery_id: uldNumber })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // setDetailsData(innerData);
                    setSelectedRowData({ ...innerData, attachable_type: 'service_recovery' });
                    setIsLoading(false)
                    setMsgSec({ service_recovery_id: innerData.service_recovery_id, recovery_status: innerData.recovery_status })
                    setEditFiles(innerData.attachments)
                    setFormData({
                        assign_to: innerData?.assign_to || null,
                        assign_to_type: innerData?.assign_to_type || '',
                        priority_id: innerData?.priority_id || null,
                        sub_status_id: innerData?.sub_status_id || null,
                        case_status_id: innerData?.case_status_id || null,
                    })
                    localStorage.setItem('RecoveryEdit', JSON.stringify(innerData))

                    const checkhandlerStn = innerData?.stations?.find(stn => stn.org_id === handlerData.org_id)
                    if (checkhandlerStn) {
                        setCloseStatus(checkhandlerStn.recovery_status);
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleButtonClick = async (button, sec) => {
        // console.log(button);
        if (sec) { setTabSec(sec) } else { setTabSec('') }
        if (!tabChange) {
            setSelectedButton(button);
            localStorage.setItem('ODTab', button);
            return
        }
        if (tabChange) {
            if (selectedButton == 'de' || selectedButton == 'st') {
                setModalConf(true);
                setConfSec('Tab')
                setConfData({
                    header: 'Unsaved Changes',
                    subHeader: 'You have unchanged changes. If you leave this page, your changes will be lost.',
                    modalConf: { tabChangeConf },
                    closeModal: { confModalClose },
                    primaryBtn: 'Leave',
                    secondaryBtn: 'Cancel',
                })
                setTabChangeData(button)
            }
        }
    }

    const tabChangeConf = () => {
        if (confSec == 'Tab') {
            setTriggerChild(prev => !prev);
            setSelectedButton(tabChangeData);
            localStorage.setItem('ODTab', tabChangeData)
            // setIsEditable(false)
        } else if (confSec == 'CR') {
            confirmCloseRecovery()
        }
        setModalConf(false);
        setTabChange(false)
    }

    const confModalClose = () => {
        setModalConf(false);
    }

    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const findPrimary = selectedRowData?.attachments?.filter((attachment) => attachment.primary === 1);
    const [highlightedFile, setHlightedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const handleImageClick = (file) => {
        setHlightedFile(file);
        setImgShow(true);
    };
    const handleClose = () => {
        setImgShow(false);
        setHlightedFile("");
    };

    const openClRec = (stat) => {
        // setCloseRecModal(true);
        setRecStat(stat);
        if (stat == 'o') {
            setConfData({
                header: 'Not All Pieces Traced',
                subHeader: 'Some pieces are still untraced. Close case anyway?',
                // modalConf: {tabChangeConf},
                // closeModal: {confModalClose},
                primaryBtn: 'Close Case',
                secondaryBtn: 'Cancel',
            })
        } else {
            setConfData({
                header: 'Re Open Recovery',
                subHeader: 'Some pieces are still untraced. Close case anyway?',
                // modalConf: {tabChangeConf},
                // closeModal: {confModalClose},
                primaryBtn: 'Re-Open Case',
                secondaryBtn: 'Cancel',
            })
        }
        // setConfModal(true);
        setModalConf(true)
        setConfSec('CR');
    }
    const closeRecModalClose = () => {
        setCloseRecModal(false)
    }
    const confirmCloseRecovery = async () => {
        const c_type = selectedRowData.recovery_status == 'Closed' ? 'o' : 'c';
        try {
            const res = await withRFSToken.post(SROPENCLOSE, { service_recovery_id: selectedRowData.service_recovery_id, action: c_type })
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        // if (isSwitchOn == true) { setIsSwitchOn(false) } else { setIsSwitchOn(true) }
                        loadDetails(selectedRowData.service_recovery_id);
                        closeRecModalClose();
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const updateRecovery = (nme) => {
        localStorage.removeItem('RecoveryUpdate');
        localStorage.removeItem('BackRecoveryUpdate');
        // let storageData = {}
        // if (nme) {
        //     storageData = { id: selectedRowData.service_recovery_id, stn: nme }
        // } else {
        //     storageData = { id: selectedRowData.service_recovery_id }
        // }
        const storageData = { id: selectedRowData.service_recovery_id, stn: nme }
        localStorage.setItem('RecoveryUpdate', JSON.stringify(storageData));

        localStorage.setItem('BackRecoveryUpdate', '/OverviewDetails');
        const fnPageUrl = '/UpdateRecoveryCase';
        window.location.href = fnPageUrl;
    }

    const formatOptionLabel = ({ label, imageUrl }, { context }) => {
        const truncateLabel = (label) => {
            if (label.length <= 3) return label;
            return label.slice(0, 3) + '...';
        };
        const displayLabel = context === 'value' ? truncateLabel(label) : label;

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {imageUrl ?
                    <img
                        src={imageUrl}
                        alt={label}
                        style={{
                            width: 18,
                            height: 18,
                            objectFit: 'cover',
                            borderRadius: 4,
                            marginRight: 10
                        }}
                    />
                    : ''
                }

                <span>{label}</span>
            </div>
        );
    };

    const dropdownChange = (name, value) => {
        console.log('0', name);
        if (name == 'assign_to') {
            setFormData(prev => ({
                ...prev,
                [name]: value.value,
                assign_to_type: value.type,
            }));
            const sendData = { ...formData, [name]: value.value, assign_to_type: value.type, }
            console.log('sendData 1', sendData);
            handleFinish(sendData)
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value.value,
            }));
            const sendData = { ...formData, [name]: value.value }
            console.log('sendData 2', sendData);
            handleFinish(sendData)
        }

    }
    const handleToggleEdit = () => {
        if (isEditable) {
            handleFinish();
            setIsEditable(false)
        } else {
            setIsEditable(true)
        }
    }

    const handleFinish = async (sendData) => {
        const getOrigin = selectedRowData.stations.find(i => i.handler_type == 'Origin');
        const getDest = selectedRowData.stations.find(i => i.handler_type == 'Destination');
        const getAir = selectedRowData.stations.find(i => i.handler_type == 'Airline');
        const getRep = selectedRowData.stations.find(i => i.handler_type == 'Reported');
        const TYPE_MAP = {
            Origin: 'Origin',
            Destination: 'Destination',
            Reported: 'Reported',
            Airline: 'Airline',
        };
        // const allStn = selectedRowData.stations.map(stn => ({
        //     ...stn,
        //     ...(TYPE_MAP[stn.handler_type] && { type: TYPE_MAP[stn.handler_type] })
        // }));
        const allStn = selectedRowData.stations.map(stn => {
            const {
                handler_feedback_id,
                station_name,
                type: handler_type,
                handler_id,
                notify_status,
                ...rest
            } = stn;

            return {
                handler_feedback_id,
                station_name,
                handler_id,
                notify_status,
                ...(TYPE_MAP[stn.handler_type] && { type: TYPE_MAP[stn.handler_type] })
            };
        });
        const transformedData = {
            ...selectedRowData,
            // origin_notify_status: selectedRowData.origin_notify_status == true ? 1 : 0,
            // destination_notify_status: selectedRowData.origin_notify_status == true ? 1 : 0,

            // all_stations: [
            //     {
            //         handler_feedback_id: getOrigin.handler_feedback_id,
            //         station_name: selectedRowData.origin,
            //         type: 'Origin',
            //         handler_id: selectedRowData.origin_handler_id,
            //         // notify_status: selectedRowData.origin_notify_status == true ? 1 : 0
            //     },
            //     {
            //         handler_feedback_id: getDest.handler_feedback_id,
            //         station_name: selectedRowData.destination,
            //         type: 'Destination',
            //         handler_id: selectedRowData.destination_handler_id,
            //         // notify_status: selectedRowData.destination_notify_status == true ? 1 : 0
            //     },
            //     {
            //         handler_feedback_id: getAir.handler_feedback_id,
            //         station_name: getAir.station_name,
            //         type: 'Airline',
            //         handler_id: getAir.handler_id,
            //         // notify_status: selectedRowData.destination_notify_status == true ? 1 : 0
            //     },
            //     {
            //         handler_feedback_id: getRep.handler_feedback_id,
            //         station_name: selectedRowData.reported,
            //         type: 'Reported',
            //         handler_id: selectedRowData.reported_handler_id,
            //         // notify_status: selectedRowData.reported_notify_status == true ? 1 : 0
            //     },
            //     ...selectedRowData.all_stations
            // ],
            all_stations: allStn,
            // ...formData
            ...sendData
            // files: [
            //     ...(formData.files || []),
            //     ...filterPrimary.map((file) => ({ id: file.id, primary: file.primary })),
            //     ...restFiles.map((file) => ({ id: file.id, primary: 0 })),
            // ]
        };
        try {
            const res = await withRFSToken.post(SAVERECOVERY, transformedData)
                .then(function (res) {
                    // setIsLoading(false);
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        setIsEditable(false)
                        loadDetails(storedData.service_recovery_id)
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchTraced = (stn) => {
        CallApi({
            endPoint: 'handler-feedback/traced-history',
            payload: { service_recovery_id: selectedRowData.service_recovery_id, type: 'traced' },
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    setModalData({ ...stn, trc: innerData, pos: 'T' })
                    setIsModalOpen(true)
                } else {
                    toast.error(data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    const handleModalOpen = (stn, pos) => {
        if (pos === 'T') {
            fetchTraced(stn)
        } else if (pos === 'S') {
            setModalData({
                ...stn,
                origin: selectedRowData.origin,
                destination: selectedRowData.destination,
                flight_prefix: selectedRowData.flight_prefix,
                flight_no: selectedRowData.flight_no,
                flight_date: selectedRowData.flight_date,
                pos: pos
            })
        }
        setIsModalOpen(true)
    }
    const handleModalClose = () => {
        setIsModalOpen(false)
        setModalData('')
    }
    const attachmentLabels = {
        IrregularityReport: 'Irregularity Report',
        DamageReport: 'Damage Report',
        ProofofDelivery: 'Proof of Delivery',
        CCTVRecord: 'CCTV Record',
        mawb: 'Master airwaybill',
        hawb: 'House airwaybill',
        con_man: 'Consol manifest',
        Invoices: 'Invoices',
        cust_dec: 'Customs declaration',
        Other: 'Other'
    };


    return (
        <>
            {console.log('closeStatus', closeStatus)}
            {isLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={tabChangeConf}
                    closeModal={confModalClose}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }
            {isModalOpen &&
                <DetailsModal
                    loadData={modalData}
                    onSave={tabChangeConf}
                    closeModal={handleModalClose}
                    pos={modalData.pos}
                />
            }
            <div className="">
                <Header page_type='srecovery' logo_url='/ServiceRecovery' />
                <div className="schedule">
                    <LeftMenu />
                    {selectedButton !== 'msg_inf' ?
                        <div className='main-panel'>
                            <button className={selectedButton === 'back' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => window.location.replace('/ServiceRecovery')}>
                                <FontAwesomeIcon icon={faArrowLeft} /> <span>Back</span><span>{selectedRowData?.master_airway_bill_prefix + ' - ' + selectedRowData?.master_airway_bill_no}</span>
                            </button>
                            <div className='maindiv'>
                                <div className='SecondDiv mt-3'>
                                    {/* <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button> */}
                                    <div className='girddtals_header'>
                                        <div className='d-flex align-items-center justify-content-between'>
                                            <h3>
                                                {selectedRowData?.master_airway_bill_prefix} - {selectedRowData?.master_airway_bill_no} &nbsp;
                                                <label
                                                    className={selectedRowData?.case_status_name == 'New' ? 'serv_new'
                                                        : (selectedRowData?.case_status_name == 'In Progress' ? 'serv_progress'
                                                            : (selectedRowData?.case_status_name == 'Closed' ? 'serv_closed' : '')
                                                        )
                                                    }

                                                >
                                                    {selectedRowData?.case_status_name}
                                                </label>
                                            </h3>
                                            <span className='age_one'>{selectedRowData?.age}</span>

                                        </div>

                                        <div className='d-flex actbtn_side justify-content-between'>
                                            <p>Traced {selectedRowData?.total_traced_pieces} Out of {selectedRowData?.pieces_involved}</p>
                                            <Button onClick={() => handleModalOpen('', 'T')}><img src={view} /></Button>
                                        </div>
                                        {/* <div className='d-flex actbtn'>
                                        <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                    </div> */}
                                    </div>
                                    <div className='mt-3'>

                                        <div className='d-flex justify-content-between rabord pt-0'>
                                            <div className='firstbrd'>
                                                <p>Origin</p>
                                                <span>{selectedRowData?.origin}</span>
                                            </div>
                                            <div className='middlebrd'>
                                                <p>{selectedRowData?.flight_date}</p>
                                                <p><img src={Cargoplane} /></p>
                                                <p>{selectedRowData?.flight_prefix}-{selectedRowData?.flight_no}</p>
                                            </div>
                                            <div className='lastbrd'>
                                                <p>Destination</p>
                                                <span>{selectedRowData?.destination}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='mt-3 mb-4'> {/* flbg */}
                                        {/* <div className='overview_head'>
                                        <h4 className='d-flex w-100 align-items-center justify-content-between'>
                                            Fields (Actions) */}
                                        {/* {selectedRowData?.isEditable && */}
                                        {/* <button onClick={handleToggleEdit} className='serv_edit_save ms-2' >
                                                <FontAwesomeIcon icon={faPencilAlt} className='pe-1' /> {isEditable ? "SAVE" : "EDIT"}
                                            </button> */}
                                        {/* } */}
                                        {/* </h4>
                                        <p></p>
                                    </div> */}
                                        <div className='fld-sl'>
                                            <Row className='mb-2'>
                                                <Col lg="4">
                                                    <Form.Label>Priority:</Form.Label>
                                                </Col>
                                                <Col lg="8">
                                                    <Select
                                                        options={priorityOpt}
                                                        onChange={(selected) => dropdownChange('priority_id', selected)}
                                                        placeholder="Select"
                                                        // className='autoslct'
                                                        name='priority_id'
                                                        value={priorityOpt.find(option => option.value === formData?.priority_id) || ''}
                                                    // isDisabled={!isEditable}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className='mb-2'>
                                                <Col lg="4">
                                                    <Form.Label>Assign User:</Form.Label>
                                                </Col>
                                                <Col lg="8">
                                                    <Select
                                                        options={assignUserOpt}
                                                        onChange={(selected) => dropdownChange('assign_to', selected)}
                                                        placeholder="Select"
                                                        // className='autoslct'
                                                        name='assign_to'
                                                        value={assignUserOpt.find(group => group.label === formData?.assign_to_type)?.options.find(opt => opt.value === formData?.assign_to) || null}
                                                    // isDisabled={!isEditable}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className='mb-2'>
                                                <Col lg="4">
                                                    <Form.Label>Case Status:</Form.Label>
                                                </Col>
                                                <Col lg="8">
                                                    <Select
                                                        options={caseStatusOpt}
                                                        onChange={(selected) => dropdownChange('case_status_id', selected)}
                                                        placeholder="Select"
                                                        // className='autoslct'
                                                        name='sub_status_id'
                                                        value={caseStatusOpt.find(option => option.value === formData?.case_status_id) || ''}
                                                    // formatOptionLabel={formatOptionLabel}
                                                    // isDisabled={!isEditable}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className='mb-2'>
                                                <Col lg="4">
                                                    <Form.Label>Sub Status:</Form.Label>
                                                </Col>
                                                <Col lg="8">
                                                    <Select
                                                        options={subStatusOpt}
                                                        onChange={(selected) => dropdownChange('sub_status_id', selected)}
                                                        placeholder="Select"
                                                        // className='autoslct'
                                                        name='sub_status_id'
                                                        value={subStatusOpt.find(option => option.value === formData?.sub_status_id) || ''}
                                                        formatOptionLabel={formatOptionLabel}
                                                    // isDisabled={!isEditable}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>

                                    {/* <div className='text-end mb-2 '><Link to='#' className="left_reco" onClick={() =>updateRecovery(null)}>Update Recovery</Link></div> */}

                                    {selectedRowData?.stations?.map((station, index) => {
                                        const rtdHandler = station.handler_type === 'Reported';
                                        const sameHandlerId = rtdHandler && selectedRowData?.stations?.some(item => item.handler_id === station.handler_id);
                                        if (sameHandlerId) return null;
                                        const rtdStn = ['Origin', 'Destination'].includes(station.handler_type) && selectedRowData?.stations?.find(item => item.handler_type === 'Reported' && item.handler_id === station.handler_id)
                                        return (
                                            <div className='recover_box mb-3 left_shipHead' key={index}>
                                                <div className='d-flex justify-content-between align-items-center up_reco_status'>
                                                    <span className={station.recovery_status === 'Closed' ? 'record_red' : 'record_status'}></span>
                                                    <div className='reco_left'>
                                                        <h4>{station.handler_type === 'Airline' ? 'Airline' : `${station.station_name} - ${station.handler_type}`} <span onClick={() => handleModalOpen(station, 'S')}><FontAwesomeIcon icon={faInfoCircle} /></span> {rtdStn && <span><img src={flag_icon} title='Reported by' /></span>}</h4>
                                                        <p>{station.handler_type === 'Airline' ? station.airline_name : station.handler_name}</p>
                                                        
                                                    </div>
                                                    <div className='reco_middle'>
                                                        <span className={station.pieces_traced == null ? '' : station.pieces_traced == selectedRowData.pieces_involved ? 'serv_trace_gr' : 'serv_trace_org'}>
                                                            {station.pieces_traced == null ? 'No Response' : station.pieces_traced == selectedRowData.pieces_involved ? 'All Completed' : `${station.pieces_traced}/${selectedRowData.pieces_involved} Pcs Traced`}</span>

                                                    </div>
                                                    {/* <div className='reco_right'>
                                                {station.isEditable && <Link to='#' onClick={() => updateRecovery(station.station_name)}><img src={update_icon} alt='update_icon' /></Link>}
                                            </div> */}
                                                </div>
                                            </div>
                                        )
                                    })}

                                    <div className='movment_history'>
                                        {/*<h3>Status Updates</h3> <Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
                                    </div>
                                    {/* <div className='movment_list'>
                                    <ul>
                                        {storedData.ULD && storedData.ULD?.status_updates.map((history, index) => (
                                            <li>
                                                <span className='movem w-auto'>{history.status}</span>
                                                <span className='mvdate'>{history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div> */}
                                    {/* <ImageUpload
                                    ref={imageUploadRef}
                                    attachable_type={"service_recovery"}
                                    attachable_id={selectedRowData?.service_recovery_id}
                                    attachments={selectedRowData?.attachments}
                                    onDeleteSuccess={() => loadDetails(selectedRowData?.service_recovery_id)}
                                    attachment_no={`${selectedRowData?.master_airway_bill_prefix} - ${selectedRowData?.master_airway_bill_no}`}
                                /> */}
                                    <ActivityComments
                                        commentable_type={"service_recovery"}
                                        commentable_id={selectedRowData?.service_recovery_id}
                                        allactivities={selectedRowData?.activities}
                                        onReloadDetails={() => loadDetails(selectedRowData?.service_recovery_id)}
                                        cmtCount={1}
                                    />
                                </div>
                                <div className='trashdonload mt-3'>
                                    <div className='d-flex justify-content-between mb-3'>
                                        <div>
                                            <button className={selectedButton === 'ov' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('ov')}>
                                                <img src={selectedButton === 'ov' ? AssetsIconw : AssetsIcon} /> <span>Overview</span>
                                            </button>
                                            <button className={selectedButton === 'de' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('de')}>
                                                <img src={selectedButton === 'de' ? AssetsIconw : AssetsIcon} /> <span>Details</span>
                                            </button>
                                            <button className={selectedButton === 'st' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('st')}>
                                                <img src={selectedButton === 'st' ? AssetsIconw : AssetsIcon} /> <span>Stations</span>
                                            </button>
                                            <button className={selectedButton === 'ch' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('ch')}>
                                                <img src={selectedButton === 'ch' ? AssetsIconw : AssetsIcon} /> <span>Charges</span>
                                            </button>
                                            <button className={selectedButton === 'msg' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('msg')}>
                                                <img src={selectedButton === 'msg' ? AssetsIconw : AssetsIcon} /> <span>Messages</span>
                                            </button>
                                            <button className={selectedButton === 'at' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('at')}>
                                                <img src={selectedButton === 'at' ? AssetsIconw : AssetsIcon} /> <span>Attachments</span>
                                            </button>
                                            <button className={selectedButton === 'do' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('do')}>
                                                <img src={selectedButton === 'do' ? AssetsIconw : AssetsIcon} /> <span>Docs</span>
                                            </button>
                                            {/* <button className={selectedButton === 'hi' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('hi')}>
                                            <img src={selectedButton === 'hi' ? AssetsIconw : AssetsIcon} /> <span>History</span>
                                        </button> */}
                                        </div>
                                        <div className='d-flex'>
                                            {/* <div>
                                            <Button onClick={updateRecovery} className='update_recovery_btn me-3'>Update Recovery</Button>
                                        </div> */}

                                            {closeStatus == 'Closed' ?
                                                <button className='close_recovery' onClick={() => openClRec('c')}>
                                                    <FontAwesomeIcon icon={faXmark} /><span> Re-open Recovery</span>
                                                </button>
                                                :
                                                <button className='close_recovery' onClick={() => openClRec('o')}>
                                                    <FontAwesomeIcon icon={faXmark} /><span> Close Recovery</span>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                    <div className='new_recovery' >
                                        {!isLoading &&
                                            <>
                                                {selectedButton === 'ov' &&
                                                    <Overview
                                                        allData={selectedRowData}
                                                        spec={spec}
                                                        cat={attachmentLabels}
                                                        sol={solutions || []}
                                                        onChildAction={() => loadDetails(selectedRowData.service_recovery_id)}
                                                        onTab={(e) => handleButtonClick(e)}
                                                    />
                                                }
                                                {selectedButton === 'de' &&
                                                    <Details
                                                        allData={selectedRowData}
                                                        trigger={triggerChild}
                                                        onChildAction={() => loadDetails(selectedRowData.service_recovery_id)}
                                                        onFormEdit={(e) => setTabChange(e)}
                                                    />
                                                }
                                                {selectedButton === 'st' &&
                                                    <Stations
                                                        allData={selectedRowData}
                                                        spec={spec}
                                                        cat={attachmentLabels}
                                                        sol={solutions || []}
                                                        onChildAction={() => loadDetails(storedData.service_recovery_id)}
                                                        onTab={(e) => handleButtonClick(e.tab, e.goTo)}
                                                    />
                                                }
                                                {selectedButton === 'ch' &&
                                                    <Charges allData={selectedRowData} onChildAction={() => loadDetails(storedData.service_recovery_id)} />
                                                }
                                                {selectedButton === 'msg' &&
                                                    <>
                                                        {!isLoading && <Message allData={selectedRowData} data={msgSec} msgSec={tabSec} linkClick={() => handleButtonClick('msg_inf')} />}
                                                    </>
                                                }
                                                {selectedButton === 'at' &&
                                                    // <Attachment
                                                    //     propdata={selectedRowData}
                                                    //     cat={attachmentLabels}
                                                    //     onChildAction={() => loadDetails(storedData.service_recovery_id)}
                                                    // />
                                                    <Attachments
                                                        propdata={selectedRowData}
                                                        Cat={attachmentLabels}
                                                        onChildAction={() => loadDetails(storedData.service_recovery_id)}
                                                    />
                                                }
                                                {selectedButton === 'do' &&
                                                    <Doc propdata={selectedRowData} onChildAction={() => loadDetails(storedData.service_recovery_id)} />
                                                }
                                                {/* {selectedButton === 'hi' &&
                                                <History />
                                            } */}
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='main-panel'>
                            <button className={selectedButton === 'back' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('msg')}>
                                <FontAwesomeIcon icon={faArrowLeft} /> <span>Back</span><span>{selectedRowData?.master_airway_bill_prefix + ' - ' + selectedRowData?.master_airway_bill_no}</span>
                            </button>
                            <div className='lcontent'>
                                <MessageInfo onLink={handleButtonClick} allData={selectedRowData} />
                            </div>
                        </div>
                    }
                </div>
            </div>

            {/* <Modal show={isModalOpen} onHide={handleModalClose} className={`addfrom change_type ${modalData?.pos ? 'traced_modal' : ''}`} centered size={`${modalData?.pos ? 'lg' : ''}`}>
                <Modal.Header closeButton>
                    {modalData?.pos && <>Traced History</>}
                </Modal.Header>
                <Modal.Body>
                    {!modalData?.pos &&
                        <>
                            <h3>Flight Information</h3>
                            <p>Flight details and ground handlers details.</p>
                            <div className='d-flex justify-content-between rabord'>
                                <div className='firstbrd'>
                                    <p>Origin</p>
                                    <span>{selectedRowData?.origin}</span>
                                </div>
                                <div className='middlebrd'>
                                    <p className='m-0'>{selectedRowData?.flight_date}</p>
                                    <p className='m-0'><img src={Cargoplane} /></p>
                                    <p className='m-0'>{selectedRowData?.flight_prefix}-{selectedRowData?.flight_no}</p>
                                </div>
                                <div className='lastbrd'>
                                    <p>Destination</p>
                                    <span>{selectedRowData?.destination}</span>
                                </div>
                            </div>

                            <div className='mawb-list mawb-dv mb-3'>
                                <h4>{modalData?.handler_type} Details:</h4>
                                <ul>
                                    <li>
                                        <span>{modalData?.handler_type === 'Airline' ? 'Airline' : 'Handler'} Name</span>
                                        <span>: {modalData?.handler_type === 'Airline' ? modalData?.airline_name : modalData?.handler_name}</span>
                                    </li>
                                    <li>
                                        <span>Address</span>
                                        <span>: test test</span>
                                    </li>
                                    <li>
                                        <span>Phone Number</span>
                                        <span>: 12452 56487</span>
                                    </li>
                                </ul>
                            </div>
                        </>
                    }
                    {modalData?.pos &&
                        <>
                            <div className='rounded' style={{ background: '#fff' }}>
                                <Table responsive borderless>
                                    <thead>
                                        <tr>
                                            <th>User</th>
                                            <th>Pieces Traced</th>
                                            <th>Tracing Date</th>
                                            <th>Updated Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {modalData?.trc?.length ?
                                            <>
                                                {modalData?.trc?.map((data, index) => (
                                                    <tr key={index}>
                                                        <td><h6>{data?.updated_by_name}</h6><p>{data?.type}</p></td>
                                                        <td>{data?.pieces_traced}</td>
                                                        <td>{data?.tracing_date}</td>
                                                        <td>{data?.updated_at_date}</td>
                                                    </tr>
                                                ))}
                                            </>
                                            :
                                            <></>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal> */}
        </>
    )
}

export default OverviewDetails;